import styled from "styled-components";

export const PieChartBox = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  min-width: 260px;
  min-height: 260px;
`;

export const PieChartStatusBox = styled.div`
  position: absolute;
  display: flex;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  align-items: center;
  justify-content: center;
`;

export const PieChartStatus = styled.div`
  display: flex;
  width: 176px;
  height: 176px;
  border-radius: 50%;
  background: ${(props) => props.theme.colors.white100};
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 15px;
`;

export const StatusDivieder = styled.div`
  height: 1px;
  width: 60%;
  background: ${(props) => props.theme.colors.black8};
`;

export const PieChartCurrent = styled.div`
  display: flex;
  align-items: center;
  color: ${(props) => props.theme.colors.primary100};
  font-size: 2.6rem;
  font-weight: 500;
  justify-content: center;
  flex-direction: column;
  gap: 5px;

  span {
    color: ${(props) => props.theme.colors.black80};
    font-size: 1.3rem;
    line-height: 1.8rem;
  }
`;

export const PieChartTotal = styled.div`
  display: flex;
  color: ${(props) => props.theme.colors.primary70};
  font-size: 1.8rem;
  font-weight: 500;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  span {
    color: ${(props) => props.theme.colors.black60};
    font-size: 1.3rem;
    line-height: 1.8rem;
  }
`;
